import { useFormikContext } from 'formik';
import {
  IQuickVideoPartOption,
  IQuickVideoPartPositionOption,
  IQuickVideoTestSendForm,
  IVideoDetails,
  QuickVideoPartType,
} from 'lib/api/quickVideo/types';
import { Flex, Gap } from 'lib/components/styles/layout';
import React, { useState } from 'react';
import { Button, Typography } from 'react-covideo-common';
import { MdAdd } from 'react-icons/md';
import { useTheme } from 'styled-components/macro';
import { AddVideoModal } from '../modals/AddVideoModal';
import { SelectedVideoCardSmall } from './SelectedVideoCardSmall';

type TestSendQuickVideoPartsProps = {
  quickVideoPart: IQuickVideoPartOption | null | undefined;
  position: IQuickVideoPartPositionOption | null | undefined;
  index: number;
  replace: <X = any>(index: number, value: X) => void;
};

export const TestSendQuickVideoPartComponent = ({
  quickVideoPart,
  position,
  index,
  replace,
}: TestSendQuickVideoPartsProps) => {
  const theme = useTheme();
  const { values } = useFormikContext<IQuickVideoTestSendForm>();

  const [openAddVideoModal, setOpenAddVideoModal] = useState(false);

  const chosenFieldValues = values.quickVideoParts[index];
  const isUserVideo =
    quickVideoPart && quickVideoPart.value === QuickVideoPartType.USER_VIDEO;
  const isDealershipVideo =
    quickVideoPart &&
    quickVideoPart.value === QuickVideoPartType.DEALERSHIP_VIDEO;

  const isDealershipVideoSelected =
    isDealershipVideo && !!chosenFieldValues.video;
  const isUserVideoSelected =
    isUserVideo && !!chosenFieldValues && !!chosenFieldValues?.video;
  const isVideoGeneratedByAI =
    !isDealershipVideo && !isUserVideo && !!quickVideoPart;

  const onOpenAddVideoModal = () => {
    setOpenAddVideoModal(true);
  };

  const onCloseAddVideoModal = () => {
    setOpenAddVideoModal(false);
  };
  return (
    <Flex width='33%' gap='11px'>
      <Gap gap='5px'>
        <Typography variant='small' fontWeight={600}>
          {position?.label || ''} -
        </Typography>
        <Typography variant='small' fontWeight={400}>
          {quickVideoPart ? quickVideoPart.label : 'None'}
        </Typography>
      </Gap>

      {isUserVideo ? (
        <Flex gap='11px'>
          {chosenFieldValues.description ? (
            <Gap height='40px'>
              <Typography
                ellipsis
                variant='small'
                color={theme.colors.neutral[60]}
                fontWeight={400}
                style={{
                  width: '100%',
                  WebkitLineClamp: 2,
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  whiteSpace: 'normal',
                }}
              >
                {chosenFieldValues.description}
              </Typography>
            </Gap>
          ) : (
            <Typography
              color={theme.colors.neutral[60]}
              variant='small'
              fontWeight={400}
              style={{
                lineBreak: 'normal',
              }}
            >
              Please add User video to proceed with test send.
            </Typography>
          )}
          {isUserVideoSelected ? (
            <SelectedVideoCardSmall
              video={chosenFieldValues?.video || ({} as IVideoDetails)}
              onClear={() => {
                replace(index, {
                  ...chosenFieldValues,
                  video: null,
                });
              }}
            />
          ) : (
            <Button
              variant='secondary'
              text='Add Video'
              icon={<MdAdd />}
              extendStyles={{
                container: {
                  height: '77px',
                  maxHeight: 'unset',
                },
              }}
              onClick={onOpenAddVideoModal}
            />
          )}
        </Flex>
      ) : (
        <Gap height='40px'>
          <Typography
            ellipsis
            variant='small'
            color={theme.colors.neutral[60]}
            fontWeight={400}
            style={{
              width: '100%',
              WebkitLineClamp: 2,
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              whiteSpace: 'normal',
            }}
          >
            {chosenFieldValues.description}
          </Typography>
        </Gap>
      )}
      {isDealershipVideoSelected && (
        <SelectedVideoCardSmall
          video={chosenFieldValues?.video || ({} as IVideoDetails)}
        />
      )}

      {(isVideoGeneratedByAI || !quickVideoPart?.label) && (
        <Flex>
          <Button
            variant='secondary'
            text='Add Video'
            icon={<MdAdd />}
            extendStyles={{
              container: {
                height: '77px',
                maxHeight: 'unset',
              },
            }}
            disabled
          />
        </Flex>
      )}

      {openAddVideoModal && (
        <AddVideoModal
          type={quickVideoPart?.value || ''}
          onClose={onCloseAddVideoModal}
          onAddVideo={(video: IVideoDetails) => {
            replace(index, {
              ...chosenFieldValues,
              video,
            });
          }}
        />
      )}
    </Flex>
  );
};
